import React from "react";
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Table from '@material-ui/core/Table';
import Paper from "@material-ui/core/Paper";
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from "@material-ui/core/TableContainer";
import Box from "@material-ui/core/Box";

export default class ComponentToPrint extends React.Component {

    render() {

        const reportData = this.props.reportData;
        const searchData = this.props.searchData;

        return (
            <div className="pl-2 pr-2">
                <h3><center><u>Lent Labour Report</u></center></h3>
                <div className="row pb-4 pt-4">
                    <div className="col"><b>Group: </b> {searchData.group}</div>
                    <div className="col"><b>Estate: </b> {searchData.estate}</div>
                    <div className="col"><b>Division: </b> {searchData.division}</div>
                    <div className="col"><b>Date: </b> {searchData.searchDate}</div>
                </div>
                <div>
                    <div className="row">
                        <div className="col-md-12">
                            <div>
                                <Box display="flex" justifyContent="flex-end" p={2}>
                                    <TableContainer component={Paper}>
                                        <Table aria-label="simple table">
                                            <TableHead>
                                                <TableRow style={{ border: "2px solid black" }}>
                                                    <TableCell align="center" style={{ fontWeight: "bold", border: "2px solid black" }}>Employee Number</TableCell>
                                                    <TableCell align="center" style={{ fontWeight: "bold", border: "2px solid black" }}>Employee Name</TableCell>
                                                    <TableCell align="center" style={{ fontWeight: "bold", border: "2px solid black" }}>Lent Estate</TableCell>
                                                    <TableCell align="center" style={{ fontWeight: "bold", border: "2px solid black" }}>Lent Division</TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {reportData.map((row, i) => (
                                                    <TableRow key={i} style={{ border: "2px solid black" }}>
                                                        <TableCell component="th" scope="row" align="center" style={{ border: "2px solid black" }}>{row.empNo}</TableCell>
                                                        <TableCell component="th" scope="row" align="left" style={{ border: "2px solid black" }}>{row.empName}</TableCell>
                                                        <TableCell component="th" scope="row" align="left" style={{ border: "2px solid black" }}>{row.transferEstate}</TableCell>
                                                        <TableCell component="th" scope="row" align="left" style={{ border: "2px solid black" }}>{row.transferDivision}</TableCell>
                                                    </TableRow>
                                                ))}
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                </Box>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
